export function generateChartSettings(featureView, featureName, availableIndexes, availableEvents, availableFormulas, rows) {
    const roundedRows = rows.map((row) => {
        return {
            cells: row.cells.map((cell) => Math.round(cell * 100) / 100),
            value: row.value,
        };
    });
    if (['pie', 'line'].includes(featureView)) {
        switch (featureView) {
            case 'pie':
                return pieChartData(availableIndexes, availableEvents, availableFormulas, roundedRows);
            case 'line':
                return lineChartData(availableIndexes, availableEvents, availableFormulas, roundedRows);
            default:
        }
    }
    return defaultChartSettings(availableIndexes, availableEvents, availableFormulas, roundedRows);
}

function getDefaultChartOptions() {
    return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: false,
        },
        scales: {
            xAxes: [{
                stacked: true,
            }],
            yAxes: [{
                stacked: true,
            }],
        },
    };
}

function getDefaultChartData(availableIndexes, availableEvents, availableFormulas, rows) {
    const localChartData = {
        datasets: [],
        labels: [],
    };
    availableEvents.forEach((event) => {
        localChartData.datasets.push({
            label: event.name,
            backgroundColor: event.color,
            data: [],
        });
    });
    availableFormulas.forEach((formula) => {
        localChartData.datasets.push({
            label: formula.name,
            backgroundColor: '#000000',
            data: [],
        });
    });
    rows.forEach((row) => {
        localChartData.labels.push(row.value);
        availableIndexes.forEach((cellIndex, datasetIndex) => {
            localChartData.datasets[datasetIndex].data.push(Math.round(row.cells[cellIndex] * 100) / 100);
        });
    });
    return localChartData;
}

function defaultChartSettings(availableIndexes, availableEvents, availableFormulas, rows) {
    const chartOptions = getDefaultChartOptions();
    const chartData = getDefaultChartData(availableIndexes, availableEvents, availableFormulas, rows);

    return {chartData: chartData, chartOptions: chartOptions};
}

function lineChartData(availableIndexes, availableEvents, availableFormulas, rows) {
    const chartOptions = _.cloneDeep(getDefaultChartOptions());
    const chartData = getDefaultChartData(availableIndexes, availableEvents, availableFormulas, rows);
    chartData.datasets = chartData.datasets.map((dataset) => {
        dataset.fill = false;
        dataset.borderColor = dataset.backgroundColor;
        dataset.tension = 0;
        dataset.borderDash = [10, 5];
        return dataset;
    });
    delete chartOptions.scales;
    return {chartData: chartData, chartOptions: chartOptions};
}

function pieChartData(availableIndexes, availableEvents, availableFormulas, rows) {
    const chartOptions = _.cloneDeep(getDefaultChartOptions());
    delete chartOptions.scales;

    const localChartData = {
        datasets: [],
        labels: [],
    };
    const eventsWithFormulas = {
        data: [],
        colors: [],
    };

    availableEvents.forEach((ef) => {
        eventsWithFormulas.data.push(0);
        eventsWithFormulas.colors.push(ef.color);
        localChartData.labels.push(ef.name);

    });
    availableFormulas.forEach((formula) => {
        eventsWithFormulas.data.push(0);
        eventsWithFormulas.colors.push('#000000');
        localChartData.labels.push(formula.name);

    });
    rows.forEach((row) => {
        availableIndexes.forEach((cellIndex, datasetIndex) => {
            eventsWithFormulas.data[datasetIndex] += +row.cells[cellIndex];
        });
    });
    localChartData.datasets = [
        {
            label: 'Events of formulas',
            data: eventsWithFormulas.data.map((eventData) => Math.round(eventData * 100) / 100),
            backgroundColor: eventsWithFormulas.colors,
        },
    ];
    return {chartData: localChartData, chartOptions: chartOptions};
}
